import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = "kai_visitor_id";
const SESSION_KEY = "kai_visit_tracked";

const genId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = genId();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

export const trackVisit = async () => {
  // Only fire once per browser session to avoid inflating visit counts.
  if (sessionStorage.getItem(SESSION_KEY)) return;
  sessionStorage.setItem(SESSION_KEY, "1");
  try {
    await axios.post(`${BACKEND_URL}/api/track-visit`, {
      visitor_id: getVisitorId(),
    });
  } catch (e) {
    // Non-blocking: tracking failures should never affect the user experience.
  }
};
